export const getSettings = state => state.reportCustomerPlans.getIn(['list', 'settings'])
export const getData = state => state.reportCustomerPlans.getIn(['list', 'data'])
export const getFetching = state => state.reportCustomerPlans.getIn(['list', 'fetching'])
export const getError = state => state.reportCustomerPlans.getIn(['list', 'error'])
